import React from 'react'
import PropTypes from 'prop-types'
import {Link as RouteLink} from 'react-router-dom'
import {Box, Image, Link, Heading} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import {pxToRem} from '../../utills/pxToRem'
import {fonts} from '../../theme/foundations/fonts'
import {blogRoute} from '../../utills/url'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

const Articles = ({article}) => {
    const {isFeatureMediaVideo, featuredMedia, id, publishDate, name, description, title} = article
    return (
        <>
            <Box
                as="article"
                marginBottom={pxToRem(20)}
                marginTop={0}
                padding={`0 ${pxToRem(5)} ${pxToRem(10)}`}
                borderBottom={'1px solid'}
                borderColor={'cav_pdp_light_gray'}
                display={'flex'}
                flexDirection={{base: 'column', md: 'row'}}
                _last={{borderBottom: 'none'}}
            >
                {isFeatureMediaVideo ? (
                    <>
                        {' '}
                        <Box>
                            <Box
                                sx={{
                                    position: 'relative',
                                    paddingBottom: '56.25%',
                                    height: 0,
                                    overflow: 'hidden',
                                    width: {base: '100%', md: pxToRem(200)},
                                    flex: '0 0 auto',
                                    my: pxToRem(12),
                                    mr: pxToRem(20)
                                }}
                            >
                                <iframe
                                    src={featuredMedia}
                                    title={'item.title'}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    referrerPolicy={'strict-origin-when-cross-origin'}
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%'
                                    }}
                                ></iframe>
                            </Box>
                        </Box>
                    </>
                ) : (
                    <>
                        <Link
                            width={{base: '100%', md: pxToRem(200)}}
                            flex="0 0 auto"
                            my={pxToRem(12)}
                            mr={pxToRem(20)}
                            to={blogRoute(`${id}.html`)}
                            as={RouteLink}
                            _hover={{textDecoration: 'none', color: 'cav_hover_brightred'}}
                        >
                            {featuredMedia ? (
                                <Image src={featuredMedia} alt={name} width={'100%'} />
                            ) : (
                                <Image
                                    src={getAssetUrl('static/img/blog-list/blplaceholder.png')}
                                    width={'100%'}
                                />
                            )}
                        </Link>
                    </>
                )}
                <Box>
                    <Heading
                        as="h4"
                        fontSize={pxToRem(14)}
                        lineHeight={pxToRem(20)}
                        letterSpacing={pxToRem(1)}
                        marginTop={pxToRem(2)}
                        marginBottom={pxToRem(15)}
                    >
                        <Link
                            key={id}
                            to={blogRoute(`${id}.html`)}
                            as={RouteLink}
                            title={title}
                            fontSize={pxToRem(14)}
                            lineHeight={pxToRem(20)}
                            letterSpacing={pxToRem(1)}
                            textAlign={'center'}
                            color={'cav_light_black'}
                            fontFamily={fonts.primary}
                            fontWeight={600}
                            _hover={{textDecoration: 'none'}}
                            dangerouslySetInnerHTML={{__html: name}}
                        ></Link>
                    </Heading>
                    <Box
                        as="p"
                        fontSize={pxToRem(12)}
                        lineHeight={pxToRem(18)}
                        letterSpacing={pxToRem(1)}
                        fontFamily={fonts.primary}
                        color={'cav_light_black'}
                        fontWeight={400}
                        marginBottom={pxToRem(5)}
                    >
                        {publishDate}
                    </Box>
                    <Box
                        as="p"
                        fontSize={pxToRem(12)}
                        lineHeight={pxToRem(18)}
                        letterSpacing={pxToRem(1)}
                        fontFamily={fonts.primary}
                        color={'cav_light_black'}
                        className="description"
                        fontWeight={400}
                        marginBottom={0}
                        dangerouslySetInnerHTML={{__html: `${description} [...]`}}
                    ></Box>
                    <Link
                        to={blogRoute(`${id}.html`)}
                        as={RouteLink}
                        fontSize={pxToRem(14)}
                        lineHeight={pxToRem(18)}
                        letterSpacing={pxToRem(1)}
                        color={'cav_red_separator'}
                        fontFamily={fonts.primary}
                        marginBottom={0}
                        fontWeight={400}
                        _hover={{
                            textDecoration: 'none'
                        }}
                    >
                        <FormattedMessage
                            defaultMessage="More..."
                            id="blog_landing.label.more_dots"
                        />
                    </Link>
                </Box>
            </Box>
        </>
    )
}

Articles.propTypes = {
    article: PropTypes.object
}
export default Articles
